import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import ActivityManagementEditBannerForm, {
  ActivityManagementEditBannerFormType,
  formToRequest,
  initialForm
} from '../../../components/admin/activity/ActivityManagementEditBannerForm'
import LoadingAndErrorFrame from '../../../components/default/frames/LoadingAndErrorFrame'
import {
  useRedirectHandleBack,
  useGetDataByParams,
  useDialogHandleSubmit
} from '../../../utils/default/ComplexFlowHook'
import useGDK from '../../../providers/admin/gdk/useGDK'
import { usePageFlow } from '../../../utils/default/PageFlowHook'
import { useCommonStyles } from '../../../utils/admin/StyleHook'
import allRoute, { Path } from '../../../components/admin/route/route'
import useT from '../../../i18ns/admin/useT'
import useGlobalDialog from '../../../providers/admin/dialog/useGlobalDialog'
import { createGlobalDialogConfig } from '../../../utils/default/DialogHelper'
import { ActivityBannerReq } from '@golden/gdk-admin'
import { useChecker } from '../../../utils/admin/AdminRouteHook'

const ActivityManagementBannerUpdatePage: React.FC = () => {
  const classes = useCommonStyles()
  const { t } = useT()
  const gdk = useGDK()
  const globalDialog = useGlobalDialog()
  const pageFlow = usePageFlow(true, false)
  const writable = useChecker()
  const [defaultForm, setDefaultForm] = useState<ActivityManagementEditBannerFormType>(initialForm())

  useGetDataByParams({
    path: Path.ACTIVITY_MANAGEMENT_BANNER_UPDATE,
    gdkFunc: (param: { id: string }) => gdk.activity.getActivityBanner(Number(param.id)),
    gdkFuncDependencies: [gdk],
    onBeforeFetch: pageFlow.setLoadingStart,
    onSuccess: (entry) => {
      pageFlow.setContentShow()
      setDefaultForm({
        activity_id: entry.activity_id,
        title: entry.title,
        showStartAt: entry.show_start_at,
        showEndAt: entry.show_end_at,
        isLongtermDisplay: entry.show_end_at === null,
        agentLongImage: entry.agent_long_image_url ? { url: entry.agent_long_image_url } : null,
        couponImage: { url: entry.coupon_image_url },
        desktopHomeImage: { url: entry.desktop_home_image_url },
        mobileHomeImage: { url: entry.mobile_home_image_url },
        isCarousel: entry.is_carousel,
        isGuest: entry.is_guest,
        isMy: entry.is_my
      })
    },
    onError: pageFlow.setGDKError
  })

  const [handleBack, handleDebouncedBack] = useRedirectHandleBack({ path: allRoute.activityManagement.encodePath({ search: {}, param: {} }) })

  const { handleSubmit } = useDialogHandleSubmit({
    formToRequest,
    globalDialog,
    dialogId: 'updateActivityBanner',
    gdkFunc: (payload) => gdk.activity.updateActivityBanner(payload as Partial<ActivityBannerReq<number>> & { activity_id: number }),
    gdkFuncDependencies: [gdk],
    getChangeDialogConfig: () => createGlobalDialogConfig({
      showIcon: false,
      message: t('dialog.confirmUpdate')
    }),
    getSuccessDialogConfig: () => createGlobalDialogConfig({
      showIcon: false,
      showCancel: false,
      message: t('dialog.updateSuccess')
    }),
    getFailDialogConfig: (_, error) => createGlobalDialogConfig({
      showIcon: true,
      variant: 'error',
      showCancel: false,
      message: error.message
    }),
    afterSuccessDialog: handleBack
  })

  return (
    <React.Fragment>
      <Box paddingY={5} paddingX={4}>
        <LoadingAndErrorFrame {...pageFlow.status}>
          <Paper>
            <Box padding={4}>
              <Typography className={classes.goldenWord} variant="h5">{writable ? t('page.updateActivityBanner') : t('page.lookActivityBanner')}</Typography>
              <Box paddingY={4}>
                <ActivityManagementEditBannerForm
                  defaultValue={defaultForm}
                  onSubmit={handleSubmit}
                  okText={t('common.confirmUpdate')}
                  onBack={handleDebouncedBack}
                />
              </Box>
            </Box>
          </Paper>
        </LoadingAndErrorFrame>
      </Box>
    </React.Fragment>
  )
}

export default React.memo(ActivityManagementBannerUpdatePage)
